// extracted by mini-css-extract-plugin
export default {"wrapper":"Cards_wrapper__jN5BL","card":"Cards_card__lMWsf","title":"Cards_title__rRm6v","description":"Cards_description__35Snv","logo":"Cards_logo__FrhVf","btn":"Cards_btn__TgAOI"};